import ticketIcon from 'assets/icons/separator/small_separator_line.svg';
import separatorLine from 'assets/icons/ticket/ticket_dark.svg';
import { getUsers } from 'components/graphql/queries';
import * as JSCookie from 'js-cookie';
import React from 'react';
import Button from 'reactstrap/lib/Button';
import { fetchGraphQL } from 'services/graphql/GraphQL';

class TicketListItem extends React.Component
  <{ [label: string]: any }>
{


  public state = {
    pt: {
      promoterName: '',
      promoterLastName: ''
    }
  }
  public componentDidMount() {

    if (this.props.promoterId !== null && this.props.promoterId !== undefined) {
      fetchGraphQL(getUsers(), JSCookie.get("token"), {
        ids: [this.props.promoterId]
      }).then((res) => {
        if (res.user.findByIds[0] === undefined) {
          // Promoter name is null anyways here
        } else {
          this.setState({
            pt: {
              ...this.state.pt,
              promoterName: res.user.findByIds[0].name,
              promoterLastName: res.user.findByIds[0].lastname
            }
          })
        }

      })
    }

  }

  public render() {
    const { price, qty, name, available, isPrivate, currency } = this.props;
    const fee = this.props.fee || 0;
    const count = this.props.qty || 0;
    const pt = this.state.pt;
    if (isPrivate === true) {
      return (
        <div className="ticket-box">
          <div className="item">
            <b className="ml-1 mr-1 pl-1 pr-1">{count}</b>
            <span className="ml-1 pl-1">x</span>
            <img src={separatorLine} alt={name} className="ticketIcon" />
            <b style={{ width: '100%' }}> {name}
              {
                this.props.description ?
                  <div className='gray-text' style={{ fontSize: '11px', width: '100%' }}>
                    {this.props.description}
                  </div>
                  : null
              }
            </b>
          </div>
          <div className="item item-reverse">
            <img src={ticketIcon} alt={name} className="separator" />
            <b>
              {
                currency === 'INR' ? <span>&#8377;</span> : '$'
              }
              {((price) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</b>
          </div>
        </div>
      );
    }

    return (
      <div className="ticket-box">
        <div
          className="only-sold-tab"
        >
          <div style={{ textAlign: 'center', width: '32%', float: 'left' }}>
            <div className='big-split-995'>
              {available > 0 ? (
                <React.Fragment>
                  <Button
                    className="button-minus"
                    onClick={e => this.props.handleSubstract(e, this.props.id, false)}
                    disabled={qty === 0 ? true : false}
                    id={'subtract' + this.props.id}
                  >
                    -
                </Button>
                  <b className="ml-1 mr-1 pl-1 pr-1">{qty || 0}</b>
                  <Button
                    className="button-plus"
                    onClick={e => this.props.handleAdd(e, this.props.id, true)}
                    disabled={qty === available ? true : false}
                    id={'add' + this.props.id}
                  >
                    +
                </Button>

                </React.Fragment>
              ) : (
                  <span className="sold-out">SOLD OUT</span>
                )}
            </div>
            <div className='small-split-995'>
              {available > 0 ? (
                <React.Fragment>
                  <div>
                    <Button
                      className="button-plus"
                      onClick={e => this.props.handleAdd(e, this.props.id, true)}
                      disabled={qty === available ? true : false}
                      id={'add' + this.props.id}
                    >
                      +
                </Button>
                  </div>
                  <div>
                    <b className="ml-1 mr-1 pl-1 pr-1">{qty || 0}</b>
                  </div>
                  <div>
                    <Button
                      className="button-minus"
                      onClick={e => this.props.handleSubstract(e, this.props.id, false)}
                      disabled={qty === 0 ? true : false}
                      id={'subtract' + this.props.id}
                    >
                      -
                </Button>
                  </div>
                </React.Fragment>
              ) : (
                  <span className="sold-out">SOLD OUT</span>
                )}
            </div>
          </div>
          <div style={{ width: '41%', float: 'left', height: '100%', alignItems: 'center', display: 'flex', paddingRight: '0 auto', paddingLeft: '0 auto' }}>
            <b style={{ width: '100%' }}>{name}
              {
                this.props.description ?
                  <div className='gray-text' style={{ fontSize: '11px', width: '100%' }}>
                    <br />{this.props.description}
                  </div>
                  : null
              }
            </b>
            {!this.props.hidePromoterName && pt.promoterName !== '' && pt.promoterLastName !== '' ? <small> {'(' + pt.promoterName + ' ' + pt.promoterLastName + ')'}</small> : null}
          </div>
          <div style={{ textAlign: 'center', width: '27%', float: 'left', height: '100%', alignItems: 'center', display: 'flex', paddingRight: '0 auto', paddingLeft: '0 auto' }}>
            {
              this.props.eventId ?
                this.props.eventId === '5dcfc36b02881a24a2e7c402' ? null : <b>
                  {
                    currency === 'INR' ? <span>&#8377;</span> : '$'
                  }
                  {((price + (fee || 0)) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</b>
                : <b>
                  {
                    currency === 'INR' ? <span>&#8377;</span> : '$'
                  }
                  {((price + (fee || 0)) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</b>
            }
          </div>
        </div>
      </div>
    );
  }

};

export default TicketListItem;



// WEBPACK FOOTER //
// ./src/components/platform/ticket-list/TicketListItem.tsx